<template>
    <div>
        <Row :gutter="10" style="margin-bottom: 8px">
            <Col>
                <DatePicker type="daterange" v-model="filter_pickUpDate" placeholder="Pickup Date"
                            :clearable="false" format="dd/MM/yyyy" style="width: 264px" @on-change="onChangeDate"></DatePicker>
            </Col>

            <Col span="5" offset="7" style="margin-top: -31px;">
                <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: dealerCityFilter}"
                             :debounce="500" :skip="skip.dealerSkip">
                    <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading"> Loading...</div>
                        <div v-else-if="error"> Error Occured. {{error}}</div>
                        <div v-else>
                            <AutoComplete placeholder="Order City" v-model="dealerCity" :clearable="true"
                                          @on-clear="onClearCity('clientCity')" @on-search="onSearchCity($event, 'clientCity')">
                                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                                    <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'clientCity')">{{cityObj.city}}</div>
                                </Option>
                            </AutoComplete>
                        </div>
                    </template>
                </ApolloQuery>
            </Col>
            <Col span="5" style="margin-top: -31px;">
                <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: pickupCityFilter}"
                             :debounce="500" :skip="skip.pickupSkip">
                    <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading"> Loading...</div>
                        <div v-else-if="error"> Error Occured. {{error}}</div>
                        <div v-else>
                            <AutoComplete placeholder="Pickup City" v-model="pickupCity" :clearable="true"
                                          @on-clear="onClearCity('pickupCity')" @on-search="onSearchCity($event, 'pickupCity')">
                                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                                    <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'pickupCity')">{{cityObj.city}}</div>
                                </Option>
                            </AutoComplete>
                        </div>
                    </template>
                </ApolloQuery>
            </Col>
            <Col span="5" style="margin-top: -31px;">
                <ApolloQuery :query="query_SEARCH_CITY" :variables="{cityFilter: droppingCityFilter}"
                             :debounce="500" :skip="skip.dropSkip">
                    <template slot-scope="{ result: { loading, error, data } }">
                        <div v-if="loading"> Loading...</div>
                        <div v-else-if="error"> Error Occured. {{error}}</div>
                        <div v-else>
                            <AutoComplete placeholder="Drop City" v-model="droppingCity" :clearable="true"
                                          @on-clear="onClearCity('dropCity')" @on-search="onSearchCity($event, 'dropCity')">
                                <Option :key="index" :value="cityObj.city" v-for="(cityObj,index) in data?data.city:[]">
                                    <div class="ivu-select-item-div" @click="onSelectCity(cityObj.city, 'dropCity')">{{cityObj.city}}</div>
                                </Option>
                            </AutoComplete>
                        </div>
                    </template>
                </ApolloQuery>
            </Col>
        </Row>
        <Row>
            <Table :columns="headers" :data="orders" @on-row-click="openOrderDetail"
                   :loading="$apollo.queries.orders.loading" size="small" stripe>
                <template slot-scope="{ row }" slot="orderNumber">
                    <span>{{row.orderNumber}}</span>
                </template>
                <template slot-scope="{ row }" slot="pickupDate">
                    <span>{{formatDate(row.pickupDate)}}</span>
                </template>
                <template slot-scope="{ row }" slot="dealer">
                    <span @click.stop="openCompanyDetail(row.clientobject.id)">
                                {{row.clientobject.name}}<br>({{row.clientobject.address[0].city}})</span>
                </template>
                <template slot-scope="{ row }" slot="pickupParty">
                        <span v-if="row.pickuppartyobject">
                            {{row.pickuppartyobject.name}}<br>({{row.pickuppartyobject.address[0].city}})</span>
                    <span v-else>-</span>
                </template>
                <template slot-scope="{ row }" slot="droppingParty">
                        <span v-if="row.droppingpartyobject">
                            {{row.droppingpartyobject.name}}<br>({{row.droppingpartyobject.address[0].city}})</span>
                    <span v-else>-</span>
                </template>
                <template slot-scope="{ row }" slot="priority">
                    <span>{{priorityObj[row.priority]}}</span>
                </template>
                <template slot-scope="{ row }" slot="internalStatus">
                    <span style="text-transform: capitalize">{{row.internalStatus.name}}</span>
                </template>
            </Table>
        </Row>

        <company-detail ref="company-detail-page"></company-detail>

        <Drawer :mask-closable="true" class="demo-drawer-prime"
                title="Order Detail" v-model="orderDetailDrawer" width="720">
            <order-detail :orderId="orderId" ref="order-detail-page"></order-detail>
        </Drawer>

    </div>
</template>

<script>
    import CompanyDetail from './CompanyDetail'
    import { SEARCH_CITY2 } from '../graphql/queries/territories'
    import {FILTER_REJECTED_ORDERS} from '../graphql/queries/Orders'
    import {SUBSCRIBE_REJECTED_ORDERS} from '../graphql/subscription/Orders'
    import OrderDetail from './OrderDetail'
    import moment from 'moment'

    export default {
        apollo: {
            orders: {
                query: FILTER_REJECTED_ORDERS,
                subscribeToMore: {
                    document: SUBSCRIBE_REJECTED_ORDERS,
                    variables() {
                        return {
                            startDate: this.startDate,
                            endDate: this.endDate,
                            clientCity: this.selectedDealerCity,
                            pickupCity: this.selectedPickupCity,
                            dropCity: this.selectedDroppingCity,
                            searchFilter: '%' + this.globalSearch + '%',
                            lrName: { lrName: this.globalSearch },
                        }
                    },
                    updateQuery: function(previousResult, { subscriptionData }) {
                        this.orders = subscriptionData.data.orders;
                    },
                },
                variables() {
                    return {
                        startDate: this.startDate,
                        endDate: this.endDate,
                        clientCity: this.selectedDealerCity,
                        pickupCity: this.selectedPickupCity,
                        dropCity: this.selectedDroppingCity,
                        searchFilter: '%' + this.globalSearch + '%',
                        lrName: { lrName: this.globalSearch },
                    }
                },
                result ({ data, loading }) {
                    if (!loading) {
                        this.orders = data.orders;
                    }
                }
            }
        },
        name: 'RejectedOrders',
        props:['globalSearch'],
        components: {OrderDetail, CompanyDetail},
        data() {
            return {
                query_SEARCH_CITY: SEARCH_CITY2,
                placeOrderDrawer: false,
                orderDetailDrawer: false,
                orderId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
                orders: [],
                headers: [
                    {title: 'Order Number', slot: 'orderNumber', width:165, className: "table-orderNum-column"},
                    {title: 'Pickup date', slot: 'pickupDate', width:125,
                        renderHeader: function (h) {return h('div', [h('p', 'Pickup'), h('p', 'Date')])}},
                    {title: 'Dealer', slot: 'dealer', className: "table-dealer-column"},
                    {title: 'Pickup Party', slot: 'pickupParty', className: "table-orderNum-column"},
                    {title: 'Dropping Party', slot: 'droppingParty', className: "table-orderNum-column",
                        renderHeader: function (h) {return h('div', [h('p', 'Dropping'), h('p', 'Party')])}},
                    {title: 'Priority', slot: 'priority', width:100},
                    {title: 'Internal Status', slot: 'internalStatus'},
                ],
                companyType: [],
                filter_pickUpDate: [moment().subtract(30, 'days').format('DD/MM/YYYY'), moment().format('DD/MM/YYYY')],
                startDate: moment().subtract(30, 'days').format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
                pickupPartyName: '',
                pickupPartyId: '',
                priority: [0, 1, 2],
                priorityObj: {0: 'Low', 1: 'Normal', 2: 'High'},
                dealerCity: '',
                pickupCity: '',
                droppingCity: '',
                skip: {dealerSkip: true, pickupSkip: true, dropSkip: true}, //To Avoid calls at initial
                dealerCityFilter: '%%',
                pickupCityFilter: '%%',
                droppingCityFilter: '%%',
                selectedDealerCity: {"address":[]},
                selectedPickupCity: {"address":[]},
                selectedDroppingCity: {"address":[]},
                companyDetailDrawer: false,
                companyId: 'aa00aa00-000a-0000-aaaa-aaaaaa00000a',
            }
        },
        computed: {},
        methods: {
            onChangeDate(evt){
                this.startDate = moment(evt[0], 'DD/MM/YYYY').format('YYYY-MM-DD')
                this.endDate = moment(evt[1], 'DD/MM/YYYY').format('YYYY-MM-DD')
            },
            onSearchCity(event, str){
                if(str === 'clientCity'){
                    this.dealerCityFilter = '%' + this.dealerCity + '%';
                    this.skip.dealerSkip = false;
                }else if(str === 'pickupCity'){
                    this.pickupCityFilter = '%' + this.pickupCity + '%';
                    this.skip.pickupSkip = false;
                }else if(str === 'dropCity'){
                    this.droppingCityFilter = '%' + this.droppingCity + '%';
                    this.skip.dropSkip = false;
                }
            },
            onSelectCity(city, str){
                if(str === 'clientCity'){
                    this.selectedDealerCity = {"address":[{"city": city}]};
                }else if(str === 'pickupCity'){
                    this.selectedPickupCity = {"address":[{"city": city}]};
                }else if(str === 'dropCity'){
                    this.selectedDroppingCity = {"address":[{"city": city}]};
                }
            },
            onClearCity(str){
                if(str === 'clientCity'){
                    this.selectedDealerCity = {"address":[]};
                }else if(str === 'pickupCity'){
                    this.selectedPickupCity = {"address":[]};
                }else if(str === 'dropCity'){
                    this.selectedDroppingCity = {"address":[]};
                }
            },
            formatDate(date){
                return moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY')
            },
            openOrderDetail(rowData, rowindex) {
                this.orderId = rowData.id
                this.$refs['order-detail-page'].$apollo.queries.orders.skip = false
                this.orderDetailDrawer = true
            },
            startAddingOrder() {
                this.placeOrderDrawer = true;
            },
            openCompanyDetail(companyId){
                this.companyId = companyId;
                this.$refs['company-detail-page'].skip = false;
                this.companyDetailDrawer = true;
            }
        }
    }
</script>

<style scoped>
    /deep/ .ivu-dropdown-item{
        padding: 0px 0px;
    }
    /deep/ .ivu-dropdown-item-div{
        padding: 7px 16px;
        width: 100%;
    }
    /deep/ .ivu-table-wrapper, .ivu-table, .ivu-table-body {
        cursor: pointer !important;
    }
    .demo-drawer-prime {
        height: calc(100% - 55px);
        overflow: auto;
        paddingBottom: 53px;
        position: static;
    }
    /deep/ .ivu-table td.table-orderNum-column{
        font-size: 14px;
    }
    /deep/ .ivu-table td.table-dealer-column{
        font-size: 14px;
    }
    /deep/ .ivu-table td.table-dealer-column div.ivu-table-cell:hover{
        background: white;
    }
    /deep/ .ivu-date-picker-cells  {
        font-size: 12px !important;
    }
</style>
